/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOfGetUserPodsResponse } from '../models/ApiResponseOfGetUserPodsResponse';
import type { ApiResponseOfUserPodsUpdateResponse } from '../models/ApiResponseOfUserPodsUpdateResponse';
import type { UserPodsUpdateBody } from '../models/UserPodsUpdateBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SupervisorPodsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @deprecated
     * Deprecated in favor of getUserPods
     * @returns ApiResponseOfGetUserPodsResponse 
     * @throws ApiError
     */
    public getSupervisorPods(): CancelablePromise<ApiResponseOfGetUserPodsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/supervisor-pod/',
        });
    }

    /**
     * @deprecated
     * Deprecated in favor of updateUserPods
     * @param requestBody 
     * @returns ApiResponseOfUserPodsUpdateResponse 
     * @throws ApiError
     */
    public updateSupervisorPods(
requestBody: UserPodsUpdateBody,
): CancelablePromise<ApiResponseOfUserPodsUpdateResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v2/supervisor-pod/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
